import { createSelector } from 'reselect'

export const getCartHistoryLoading = createSelector(
  (state) => state && state.cart && state.cart.history && state.cart.history.itemsLoading,
  isLoading => isLoading
)
